import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * A command sent by the rovo client to abort the ongoing message.
 *
 * @summary {@link CommandProperties.senderId} is letting {@link CommandProperties.receiverId} know that the ongoing message has been aborted.
 */
export const RovoChatAbortMessageCommand = createCommand<CommandProperties>(
	'rovo-chat-abort-message-command',
);
